export enum ChavesArmazenamentoLocal {
  ULTIMO_CURSO_ACESSADO = 'ultimo_curso_acessado',
  SESSION_TOKEN = 'sessionToken',
  PRIMEIRO_ACESSO = 'primeiro_acesso',
}
